import { createSelector } from '@reduxjs/toolkit';
import Fuse from 'fuse.js';

import type { RootState } from '@/lib/store';
import { exerciseSliceSelectors } from '@/entities/exercise/model/exercise.selector';

const fuseOptions = {
	keys: [
		{ name: 'movement.name', weight: 0.4 },
		{ name: 'movement.canonicalName', weight: 0.4 },
		{ name: 'equipment.name', weight: 0.1 },
		{ name: 'equipment.canonicalName', weight: 0.1 },
	],
	threshold: 0.3, // 0.0 = exact match, 1.0 = match anything
	includeScore: true,
	minMatchCharLength: 2, // Start searching at 2+ characters
	ignoreLocation: true, // Search anywhere in the string
};

const selectSearchResults = createSelector(
	[exerciseSliceSelectors.selectAllPopulated, (state: RootState) => state.exerciseSearch.query],
	(populatedExercises, searchTerm) => {
		// Show all exercises if no search term or term is too short
		if (!searchTerm || searchTerm.length < 2) {
			// return all exercises sorted by most recently updated
			return populatedExercises.slice().sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
		}

		// Create Fuse instance and perform fuzzy search
		const fuse = new Fuse(populatedExercises, fuseOptions);
		const results = fuse.search(searchTerm);

		// Return the exercise items (limit to top 50 matches for performance)
		return results.slice(0, 50).map((result) => result.item);
	},
);

const exerciseSearchSliceSelectors = {
	selectSearchResults,
};

export { exerciseSearchSliceSelectors };
